var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgImgMessagingInteractionr = function SvgImgMessagingInteractionr(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 146,
    height: 100,
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#DFE2E5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    strokeWidth: 0.8,
    d: "M133.011 90.163a2.223 2.223 0 0 1-2.222 2.222H77.26a2.223 2.223 0 0 1-2.222-2.222V78.188c0-1.226.996-2.222 2.222-2.222h53.529c1.227 0 2.222.996 2.222 2.222z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DFE2E5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    strokeWidth: 0.8,
    d: "M69.513 25.193v-14.69A2.223 2.223 0 0 0 67.29 8.28H13.76a2.223 2.223 0 0 0-2.221 2.223v18.68c0 1.227.995 2.223 2.222 2.223h45.313"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M48.632 57.77c.36 4.436 9.461 5.629 3.163 14.44-1.27 1.774-7.779-1.493-7.779-1.493l-.909-9.19z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    fillRule: "evenodd",
    d: "M66.61 63.483a1.44 1.44 0 0 0-1.282 1c-1.69 5.27-3.47 10.22-5.428 14.586 0 0-4.479-6.166-7.648-8.628-5.661-4.398-12.973-3.805-12.973-3.805s-14.261 3.876-17.175 8.424c-3.526 5.504-3.19 17.326-3.19 17.326h35.13c.483-.742 1.289-.948 1.462-2.6 0 0 4.915 7.507 10.188.838 2.952-3.735 4.69-21.428 4.997-24.814.04-.43-.115-.855-.422-1.158-.987-.937-2.397-1.25-3.66-1.17",
    clipRule: "evenodd"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M44.944 64.288v5.513a2.22 2.22 0 0 1-1.066 1.897c-4.22 2.512-8.987 1.805-12.192-.279l-7.343-14.974s7.488-9.364 11.051-10.752c5.371-2.092 10.273 2.295 10.273 2.295 4.051 5.653 4.084 13.998-.723 16.3M69.984 64.926c-.848.463-3.118-.031-3.765-1.175-.76-1.346-.98-4.703-.793-6.898.185-2.181 1.91-6.281 1.91-6.281l.625 2.083.162-.443c1.319-.096 1.564.987 1.63 2.265-.747 2.997.978 4.623 1.558 6.5.276.892-.476 3.487-1.327 3.949",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1,
    strokeWidth: 0.8,
    d: "M66.247 63.704c-.294-1.719-.88-5.157-.757-7.176.105-1.713.827-3.596 1.498-4.929.596-1.183 2.526-3.066 2.526-3.066"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1,
    strokeWidth: 0.8,
    d: "M66.988 57.392a59 59 0 0 1 1.114-5.174c1.452-.115 1.771 1.147 1.457 3.929-.245 2.165 2.345 3.053 1.139 7.912"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#EFF2F4",
    fillRule: "evenodd",
    d: "M44.944 68.27v-3.982q.63-.303 1.15-.736c-2.546 1.817-5.315 1.505-7.907.392 0 0 1.164 5.72 4.391 5.424 1.079-.099 1.836-.522 2.366-1.097",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M45.357 47.942s-4.068-.857-8.87 1.1c-.877.358-1.35.956-1.596 1.69-.35 1.048 1.811 3.143-.503 4.593-1.331.833-1.449-1.438-3.716.83-.456.455-.89 2.902 2.13 4.99 2.761 1.91 6.654 9.554 2.565 14.506-5.063 6.13-13.848 3.258-15.88-2.35-1.774-4.892.772-21.149 4.856-26.866 5.718-8.005 17.685-8.112 22.6-3.198 3.165 3.164-.038 6.594-.038 6.594z",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    strokeWidth: 0.8,
    d: "M45.667 47.988c6.23 9.307 2.109 20.248-7.48 15.95M32.803 55.458c-1.256-.496-2.503.787-2.218 2.052.194.862.895 2.518 3.367 1.796M52.684 80.013c3.717 5.299 4.423 9.193 1.406 12.372M30.643 85.55c-.094 2.686-.085 4.952.017 6.835M60.9 76.862l-1.405 3.15"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    strokeWidth: 0.8,
    d: "M44.462 54.283s1.471 2.809 1.205 3.487c-.453 1.15-1.899.73-1.899.73M45.018 60.319c-1.65 1.677-4.248 1.128-5.14-.288"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M46.72 54.855c.39-.085.624-.529.524-.992s-.498-.77-.888-.685-.625.529-.525.992c.101.463.499.77.889.685M41.9 55.9c.39-.084.626-.528.525-.991s-.498-.77-.888-.685-.625.528-.524.992.498.77.888.685"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M42.317 51.165c.384.026.676.92.338 1.106-.468.257-1.792.072-3.164.558-.505.179-.993.52-1.238.567-.132.025-.396-.078-.347-.204.057-.148.639-.8 1.342-1.149 1.075-.53 2.501-.916 3.069-.878M45.13 50.755c-.314.146-.246.928.126 1.03.438.118 1.757-.33 2.661-.114.184.044-.015-.934-.341-.973-.92-.108-2.06-.124-2.447.057",
    clipRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    strokeWidth: 0.8,
    d: "M69.512 52.969V39.14c0-1.22-.99-2.21-2.21-2.21H13.749c-1.22 0-2.21.99-2.21 2.21v33.402M11.539 79.477v10.698c0 1.221.99 2.211 2.21 2.211h53.553c1.22 0 2.21-.99 2.21-2.21v-19.79M11.461 72.6l-6.727 6.727a.857.857 0 0 0 .607 1.466h6.047"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M107.723 39.918a3.5 3.5 0 0 0-1.518 2.088 5.5 5.5 0 0 0-.143 1.282s-4.943 3.994-6.48 7.06c-2.167 4.322-3.572 20.093-3.572 20.093h34.763a2.24 2.24 0 0 0 2.239-2.239v-31.66c-1.536-1.07-3.803-2.2-10.102-1.985-.958-.743-3.206-2.181-4.505-1.408 0 0-8.333 5.28-10.682 6.77",
    clipRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    strokeWidth: 0.8,
    d: "M105.479 59.046c1.251 4.087 3.139 8.101 5.184 10.512M106.487 43.973c.924 2.885 2.588 4.685 5.455 5.577-.202-1.536.049-3.003.904-4.378M114.511 44.63c1.437.6 2.468 1.824 3.335 3.3 3.47-2.487 5.999-6.665 5.139-12.33M113.292 48.534c2.711 7.734 7.415 15.44 11.812 21.024M115.821 50.449l1.404-.677M117.794 54.664l1.404-.678M120.116 59.047l1.404-.677M122.63 63.279l1.404-.677M125.561 67.856l1.404-.677"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M96.01 23.23s4.714 11.564 7.664 13.973c.822.671 3.136.549 3.136.549l3.235 5.713c3.788 1.483 9.493-2.514 10.364-6.85l-5.898-11.485c.188-1.766-.114-3.087-1.587-3.34l-4.409-5.723z",
    clipRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#EFF2F4",
    fillRule: "evenodd",
    d: "M108.743 41.167c.726.27 1.505.333 2.297.033 3.069-1.163 1.867-7.608 1.867-7.608-1.882 2.285-4.002 4.287-8.23 3.79 0 0 .058.096.168.26.931.164 1.964.11 1.964.11z",
    clipRule: "evenodd"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M115.992 27.988s1.088-3.91.916-5.995c-.263-3.18-2.03-8.198-4.71-9.826s-8.229-1.66-11.372.055c-3.143 1.716-9.467 5.311-7.485 10.237 1.059 2.63 4.543 4.953 4.543 4.953l-.671-2.144s3.345-4.668 7.902-4.81c1.781-.057 1.434 3.351 3.804 3.899.731.169 1.229-.575 1.229-.575 0-1.85 1.06-1.898 2.275-2.04 1.779.048 2.287 1.6 2.088 3.348-.254 1.698.449 2.18 1.481 2.898",
    clipRule: "evenodd"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    strokeWidth: 0.8,
    d: "M96.973 24.978c1.4 3.866 4.527 9.942 6.554 11.82 1.374 1.273 4.476.752 5.678.08 1.47-.822 3.702-3.45 3.702-3.45M111.336 22.502c.677-1.11 2.38-.85 2.897.288.351.776.774 2.454-1.544 3.337M106.672 37.577l3.795 6.748M114.893 26.14l5.831 11.021"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    strokeWidth: 0.8,
    d: "M102.394 29.193s.219 3.367 1.131 3.894c.589.341 1.856-.85 1.856-.85M106.062 34.325c1.569-.406 2.602-1.805 2.486-3.903"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M105.532 28.162c.351-.195.448-.69.217-1.104s-.702-.591-1.053-.396-.448.69-.217 1.104.702.592 1.053.396M101.243 30.559c.351-.196.448-.69.217-1.105-.231-.414-.702-.591-1.053-.396-.351.196-.448.69-.217 1.104s.702.592 1.053.397"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M102.014 25.126c-.299.295.356 1.051.774.997.58-.075 2.302-1.046 2.708-1.447.237-.235.058-1.005-.273-.962-.58.074-2.803 1.01-3.209 1.412M99.717 26.453c.418-.05.669.83.44 1.184-.24.372-1.458.998-1.885 1.05-.33.04-.854-.46-.673-.74.24-.372 1.692-1.442 2.118-1.494",
    clipRule: "evenodd"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    strokeWidth: 0.8,
    d: "M131.738 38.416c.319-1.14 1.023-2.216 2.721-3.006"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    strokeWidth: 0.8,
    d: "M132.717 36.628c.417-.45.979-.863 1.742-1.218M132.573 44.103c.337.334.739.625.975.797M132.987 33.181v-6.336l.061-.012 6.727-6.726a.855.855 0 0 0 .186-.936.86.86 0 0 0-.793-.53h-6.047M132.987 20.855v-10.39c0-1.22-.99-2.21-2.21-2.21H77.224c-1.22 0-2.21.99-2.21 2.21v14.713M75.014 42.517v25.65c0 1.22.99 2.21 2.21 2.21h53.553c1.22 0 2.21-.99 2.21-2.21V48.375"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M90.17 72.074c-.889-.167-1.54-.483-1.538-1.22 0 0-.728-3.209 2.473-3.933 1.693-.384 4.134-.209 6.13.718 1.394.645 1.99 2.276 1.99 2.276h-2.298l-.7 3.422c-.22.851-.843 1.232-1.52.925-.982 1.103-1.924 1.428-2.46.846v-1.283c-.625.881-1.474 1.41-2.21.76z",
    clipRule: "evenodd"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1,
    strokeWidth: 0.8,
    d: "M99.215 69.855s-.859-1.585-1.733-2.118c-1.41-.86-6.626-2.023-8.377.448-.526.743-.75 3.26-.747 4.004.003.872.838 1.046.838 1.046"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1,
    strokeWidth: 0.8,
    d: "M90.64 69.212c-.383 1.55-.72 4.581-.563 5.323.069.328.692.43 1.174.246M92.742 68.695s-.668 5.517-.452 6.429c.067.279.96.354 1.604-.056M95 69.212a33 33 0 0 0-.448 4.896c0 .144.13.262.296.273.444.024 1.236-.068 1.352-1.004.26-2.092.727-3.685.727-3.685"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M132.453 42.06c-1.596.503-4.597 3.15-3.681 6.627.209.79 1.185 2.147 1.185 2.147-.407.622-.711 1.188-.107 1.756a.35.35 0 0 0 .411.072c.353-.15.68-.338.991-.639.326.2 3.107 1 3.834.364.22-.191.355-.834.086-1.21-.239-.334-.66-.404-.66-.404.316-.431.478-1.09.059-1.753 0 0 .272-.302.325-.448.268-.736-.297-1.48-.297-1.48s.766-1.003.214-2.016c-.41-.753-1.327-.276-1.327-.276l-1.032-.82z",
    clipRule: "evenodd"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    strokeWidth: 0.8,
    d: "M129.891 48.466c.409.686 1.023 1.336 1.505 1.635.833.515 2.342.835 2.92.605.381-.152.482-.494.488-.8M130.39 46.675s.897 1.267 1.552 1.633c.694.389 2.124.823 2.61.696.461-.12.563-.684.471-1.091M131.466 45.235s.894 1.054 1.406 1.369c.394.242 1.236.647 1.747.444.424-.168.37-.742.336-1.135-.035-.391-.309-.97-.542-1.217"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    strokeWidth: 0.8,
    d: "M128.762 49.352c.346.756 1.189 2.042 2.177 2.542.989.5 3.179.769 3.754.46.376-.201.453-.673.413-1.012"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    strokeWidth: 0.8,
    d: "M102.317 52.327c-1.704-1.484-3.75-2.135-5.483-2.14"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    strokeWidth: 0.8,
    d: "M99.707 50.748a8.1 8.1 0 0 0-2.873-.56"
  })), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    fillRule: "evenodd",
    d: "M89.849 33.745a6.754 6.754 0 0 0-6.753-6.755H66.771a6.76 6.76 0 0 0-6.752 6.755A6.76 6.76 0 0 0 66.77 40.5h16.325a6.754 6.754 0 0 0 6.753-6.755",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    fillRule: "evenodd",
    d: "M89.797 34.477c-1.834 1.508-3.43 3.487-2.36 4.31 2.611.903 4.316-.217 5.579-1.431.103-.1.162-.219.134-.344-.029-.125-.128-.251-.273-.271-1.431-.198-3.107-.669-3.08-2.264",
    clipRule: "evenodd"
  }), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    strokeWidth: 0.8,
    d: "M60.019 33.745A6.76 6.76 0 0 0 66.77 40.5h4.499M88.975 37.071c.56-.982.874-2.117.874-3.326M58.488 27.72c.628-1.738 1.976-3.017 4.179-3.355M60.552 22.028c.905-.438 1.979-.598 3.215-.39"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    strokeWidth: 0.8,
    d: "M74.936 35.535a1.79 1.79 0 1 0 0-3.581 1.79 1.79 0 0 0 0 3.581M68.238 35.535a1.79 1.79 0 1 0 0-3.581 1.79 1.79 0 0 0 0 3.581M81.634 35.535a1.79 1.79 0 1 0 0-3.58 1.79 1.79 0 0 0 0 3.58"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgImgMessagingInteractionr);
export default ForwardRef;